import React from 'react';
import { useEffect , useContext} from 'react';
import { useLocation , useNavigate} from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import ProfileNotes from '../components/common/ProfileNotes';
import ProfileYouTube from '../components/common/ProfileYouTube';
import './styles/Class.css';
import { AuthContext } from '../context/AuthContext';



const Class = () => {
  const { auth } = useContext(AuthContext);
    const location = useLocation();
    const { teacher } = location.state || {}; 
    const navigate = useNavigate();
    // const role = localStorage.getItem('role')




    useEffect(() => {
      if (!auth.isAuthenticated ) {
        navigate("/login")
      }    
    }, [auth, navigate]);
  
    if (!auth.isAuthenticated) {
      return null;
    }

    const image = `${process.env.REACT_APP_POCKETBASE_URL}/api/files/${teacher.collectionId}/${teacher.id}/${teacher.avatar}`;
    const noteUrl = `${process.env.REACT_APP_POCKETBASE_URL}/api/files/${teacher.collectionId}/${teacher.id}/${teacher.note_background}`;
    const recordUrl = `${process.env.REACT_APP_POCKETBASE_URL}/api/files/${teacher.collectionId}/${teacher.id}/${teacher.record_backgroud}`;

    return (
        <div className="class-details-card">
          <button  className="back-button" onClick={() => window.history.back()}>
            <ArrowBack /> Back to Profile
          </button>
    
          <div className="teacher-header flex justify-evenly">
            <img alt='' className="profile-image" src={image}/>
            <div>
            <h2>{teacher.name}</h2>
            <p>{teacher.description || 'A grade'}</p>
            </div>
          </div>
    
          <div className="class-sections">
            <section className="notes-section">
              <h3>Class Notes</h3>
              <ProfileNotes  teacherId={teacher.id} noteUrl={noteUrl}/>
              {/* <button className="view-all-btn">View All Notes</button> */}
            </section>
    
            <section className="recordings-section">
              <h3>Class Recordings</h3>
              <ProfileYouTube  teacherId={teacher.id} recordUrl={recordUrl}/>
              {/* <button className="view-all-btn">View All Recordings</button> */}
            </section>
          </div>
        </div>
      );
};


export default Class;